module.exports = __webpack_public_path__ + "components/country-flag/static/pt-d43120f51ab7592f8c04de516c19ba9f.svg";